
var $ = require('jquery'); 
$(document).ready(function() {
  if($('div').hasClass('covid-notice'))
  {
    $('body').addClass("announc-body");
  };
  // $('.closing-main-strip').click(function(){
  //     $('body').removeClass("announc-body");
  // });  
});
$(document).ready(function(){
  $(".head-top-right").click(function(){
    $(this).toggleClass("show");
    $(".head-top-indiv.show").trigger("click");
  });
 
  $(".head-top-indiv").click(function(){
    $(this).toggleClass("show");
    $(".head-top-right.show").trigger("click");
  });
});
$(".main-content").click(function()
  {
    $(".head-top-right").removeClass('show');
      // var hascls = $(".head-top-right").hasClass("show");
      // if (hascls) {
      //     $(".head-top-right").click();
      // }
  });

// Overlay when hover the mega menu
var nav_menu = $('nav li.mega-dropdown, .fixed-header nav li.mega-dropdown');
var content_overlay = $('#content_overlay');
var headerWrap = $('header');
var windowWidth = $(window).width();
// Toggle Menu
var toogleButton = $('button.navbar-toggle');  
toogleButton.on('click', function () {    
    $('.nav, .hdr--right').toggle('fast', function () { });
});

// Mega menu
if (windowWidth > 1200) {  
    nav_menu.mouseover(function () {
        $(this).addClass('open');
        content_overlay.addClass('activate');
    });

    nav_menu.mouseout(function () {
        $(this).removeClass('open');
        content_overlay.removeClass('activate');
    });
}
// Overlay when hover the mega menu end

// header-search js start
$(document).ready(function()
  {
   $(".head-search a").click(function(){      
    $(".search-megamenu").toggleClass("search-megamenu-open");
  });
});
// header-search js end

// header js start
$(document).ready(function () {
    $(".navbar-toggle").on("click",function(){$(this).toggleClass("active")
  });
 });
//  header js end



/* global search related*/

$(document).ready(function () {
  $(".mainsearch-btn").click(function () {
      var searchvalue = $(".mainsearch-input").val();
      var url = $(".searchpage-url").text();
      url = url + "&searchQuery=" + searchvalue + "&wordsMode=0";
      window.location.href = url;
  })
  $(".mainsearch-input").keydown(function (e) {
    var key = e.which;
    if (key == 13)  // the enter key code
    {
        $(".mainsearch-btn").trigger("click");
    }
});

  function set_cookie(cookie_name, cookie_value, lifespan_in_days, valid_domain) 
{
   lifespan_in_days = 90; 

 }
 function EuropeCountries(profid,ccode){
  var key =profid+','+ccode;
set_cookie("PICountryCookie", decodeURIComponent(key), 20, "");document.location.href='/lu/funds/fund-prices/all-funds?fundtype=all';}

})

/* global search related end*/


// cookies js 12-10-2022


$(document).ready(function(){
  $(".head-mob .mega-dropdown").click(function(){
    $(".head-mob .mega-dropdown").not(this).removeClass("open-tab");
    $(this).toggleClass("open-tab");
  });
});


$(document).ready(function () {
  // $(".lnkeurope").click(function () {
  //     var ccode = $(this).attr('data-ccode');
  //     var profId = 'PI';
  //     $('#country-popup-lu .modal-header').attr('data-ccode', ccode);
  //     $('#country-popup-lu .modal-header').attr('data-profileid', profId);
  // });
  var modelData = [];
  if($('#dataContainer').length>0)
  {
  var modelData = $.parseJSON($('#dataContainer').attr('data-model'));
  $(".topcountrypopup").click(function () {
      var countrycode = $(this).attr("data-ccode");
      var countrydis = $.grep(modelData, function (modelData) {
          return modelData.CCode === countrycode;
      });
      $("#country-disclaimer-data").html(countrydis[0].DisclaimerData);
      
         
  });
  $(".lnkeurope").click(function () {
      var countrycode = 'AT';
      var countrydis = $.grep(modelData, function (modelData) {
          return modelData.CCode === countrycode;
      });
      $("#country-disclaimer-data").html(countrydis[0].DisclaimerData);
      var ccode = $(this).attr('data-ccode');
      var profId = 'PI';
      $('#country-popup-main .modal-header').attr('data-ccode', ccode);
      $('#country-popup-main .modal-header').attr('data-profileid', profId);
     
  });
}
  
  
})



//    read-less js start

$('.moreless-button').click(function() {
  $('.more-text-company').slideToggle();
  if ($('.moreless-button').text() == "Read more") {
    $(this).text("Read less")
  } else {
    $(this).text("Read more")
  }
});

//    read-less js end


// covid js start


$(document).ready(function(){
    $('.covid-slider').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow:1,
        slidesToScroll: 1,
        adaptiveHeight: true,
              
      });
});

$(document).ready(function () {
    $(".closing-main-strip").click(function(){
        $(".covid-notice").hide();
        $('body').removeClass("announc-body");
        $(".header-covid").addClass("header-covid-margin-remove");
        $(".main-content").removeClass("main-content-covid");
        $("header").css('top', '0');
        $(".main-content").css('margin-top', $("header").height());
      });
$(document).on('click','.closing-main-strip',function(){
  $(".covid-notice").hide();
  $('body').removeClass("announc-body");
  $(".header-covid").addClass("header-covid-margin-remove");
  $(".main-content").removeClass("main-content-covid");
  $("header").css('top', '0');
  $(".main-content").css('margin-top', $("header").height());

});
// covid js end
var country = $(".currentcountry-id").attr("value");
if(country==undefined)
{
  country="other";
}

  if (window.location.href.indexOf("/lu") == -1 && !(country.includes("us"))) {
    $(".head-top-indiv-menu li a").on("click", function (e) {
        e.preventDefault();
        var investortype = $(this).attr("data-profileid");
        if (investortype.toLocaleLowerCase() == "npi") {
            window.location.href = window.location.origin;
        }
        if (investortype.toLocaleLowerCase() == "offshore") {
          window.location.href = window.location.origin +"/offshoreadvisor";
      }
      if (investortype.toLocaleLowerCase() == "alwara") {
        window.location.href = window.location.origin +"/myalwarainvestments";
    }
    })
    $(".mob-country-Profile li a").on("click", function (e) {
        e.preventDefault();
        var investortype = $(this).attr("data-profileid");
        if (investortype.toLocaleLowerCase() == "npi") {
            window.location.href = window.location.origin;
        }
        if (investortype.toLocaleLowerCase() == "offshore") {
          window.location.href = window.location.origin +"/offshoreadvisor";
      }
      if (investortype.toLocaleLowerCase() == "alwara") {
        window.location.href = window.location.origin +"/myalwarainvestments";
    }
    })
  }

  $('.more-data').on('click',function(){
    $('.more-data').show();
    $(this).hide();
    var txt = $('.more-data:eq(0)').text();
    if(txt=='Read more..'){
        $('.more-data').text('Read less..');
       $('.more-txt').show();
       $('.more-txt').removeAttr('style');
    }
    else{
        $('.more-data').text('Read more..');
      $('.more-txt').attr('style','display:none;');
        $('.more-txt').hide();
    }
});
$('.iframe-popup-close').on('click',function(){$('iframe').attr('src','');});
});


    setTimeout(function(){ 
      var windowWidth = $(window).width();
      if(windowWidth > 1200 && window.location.href.indexOf("jp")==-1)
      {
        var cheight=$(".covid-notice").height()+30;
        var maincontentheight=$("header").height()+cheight;
        $(".announc-body header").css('top', cheight);
        $(".announc-body .main-content").css('margin-top', maincontentheight);
      }
    }, 500);
    $(document).on('click','.btn-secondary.accepttext',function(){
      var a =$(this).attr('href'); 
      document.location.href=a;
      });
      $(document).on('click','.btn-disclaimer-cancel',function(){
        var a =$(this).attr('href'); 
        document.location.href=a;
        });
        $(document).on('click','.acceptLUContent',function(){
          var ccode = $('#country-popup-main .modal-header').attr('data-ccode');
          var profId = $('#country-popup-main .modal-header').attr('data-profileid');
          var currentcountry=$("#currentcountrycode").attr("value");
          //EuropeCountries(profId, ccode);
          var key = profId + ',' + ccode;
          set_cookie("ShowCountryPopup", ccode, 20, "");
          set_cookie("ShowInvestorTypePopup", "", 20, "");
          //set_cookie("PICountryCookie", decodeURIComponent(key), 20, "");
          var urlappend="?select_domain="+currentcountry+ "-" +""+ccode;
          var stageurl="https://uat-eastspring.devtpit.com/lu/";
          var liverrl="https://www.eastspring.com/lu/";
          if(window.location.href.indexOf('uat')>-1)
          {
            if(currentcountry=="kr")
            {
              stageurl=stageurl+urlappend;
            }
            document.location.href = stageurl;
          }
          else{
            document.location.href = liverrl;
          }
          
      });
      function set_cookie(cookie_name, cookie_value, lifespan_in_days, valid_domain) {
        lifespan_in_days = 90; //As of now cookie expiry is limited to 90 days.
        var domain_string = valid_domain ? ("; domain=" + valid_domain) : '';
        if (window.location.href.indexOf('https') != -1)
            document.cookie = cookie_name + "=" + encodeURIComponent(cookie_value) +
                "; max-age=" + 24 * 60 * 60 * 1 * lifespan_in_days + //24(Hrs) * 60(Mins) * 60(Secs) * 1(NanoSecs) * lifespan_in_days(No.of days)
                "; path=/" + domain_string + "; secure;SameSite=Lax";
        else
            document.cookie = cookie_name + "=" + encodeURIComponent(cookie_value) +
                "; max-age=" + 24 * 60 * 60 * 1 * lifespan_in_days + //24(Hrs) * 60(Mins) * 60(Secs) * 1(NanoSecs) * lifespan_in_days(No.of days)
                "; path=/" + domain_string;
  
  
    }

